import purpleFlower from "../assets/icons/purpleFlower.webp";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";

const SelectCardUser = ({ text, link, icon }) => {
  return (
    <div className="flex md:m-4 m-1 items-center justify-center rounded-xl shadow-md border border-accent-green  py-16 md:px-6 px-2  w-full md:max-w-[380px] max-w-[380px] h-[200px]">
      {/* Icono */}
      <div className={`w-[20%] ${!icon ? "bg-light-green rounded-3xl" : ""}`}>
        <img src={icon || purpleFlower} />
      </div>

      <span className=" w-[60%] p-4 text-dark-green text-xl  text-wrap font-poppins">
        {text}
      </span>
      {/* Botón */}
      <Link to={link} className="w-[20%] flex items-center justify-center">
        <button className=" w-full m-2 rounded-full flex justify-center bg-dark-green text-white  py-4 px-0 md:px-6 hover:bg-accent-green transition-all duration-100">
          <FaArrowRightLong className="w-4 mx-0  text-xl" />
        </button>
      </Link>
    </div>
  );
};

export default SelectCardUser;
